import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import Topbar from "./Topbar";

function MainContainer({ hideHeader = false }: { hideHeader?: boolean }) {

  return (
    <>
      {!hideHeader && <Topbar />}
      <Box
        component="main"
        className="main_content"
        sx={{
          marginLeft: "auto",
          width: "100%",
        }}
      >
        <Container className="sub-layout">
          <Outlet />
        </Container>
      </Box>
    </>
  );
}
export default MainContainer;
